<template lang="pug">
  div.checkout-cart-comp
    IconPaperTop()
    div.checkout-cart-content(v-if="cart.ordersItem")
      div.checkout-cart__head
        h3 Thông tin giỏ hàng
      div.checkout-cart__body

        div.checkout-cart__items
          div.checkout-cart__item(v-for='(item,index) in cart.ordersItem')
            div.item-card__head
              span.item-card__item-name {{item.order.Item_Name}}
              span.item-card__close(@click.prevent="removeItem(index)")
                IconRemove()
            div.item-card__body
              .options(v-if='!item.order.isCombo')
                .item-card__option(v-for='(op,key) in item.order.options')
                  template
                    span.item-card__option-name {{op.name}}
                    span.item-card__option-info
                      span.opVal(v-for='val in op.options') {{val}}
                      .opDetailsList(v-if='op.model')
                        span.item-card__option-details(v-for='s in op.model' v-if='s.quantity > 0')
                          | {{ s.name }} x {{ s.quantity }}
              .options(v-else='')
                .item-card__option(v-for='(op,key) in item.order.options')
                  span.item-card__option-info(v-for='val in op.details' v-if='op.selected === val.Item_Id') {{val.Item_Name}}

            div.item-card__foot
              span
                cart-quantity(v-model='item.order.Quantity' @input="updateCart")
              span.item-card__amount {{((item.order.Price + item.order.plusPrice) * item.order.Quantity ) | formatPrice}}

      div.checkout-cart__foot
        div.fields.checkout-cart__summary
          span.field-caption Tổng {{cart | countTotalItems}} món
          span.field-value {{cart | totalPrice}}

        template(v-if=" shipType && shipType.name && 'pickup' !== shipType.name")

          div.fields.checkout-cart__shipment-fee(v-if="cart.ship_price_real >= 0")
            span.field-caption Phí vận chuyển
            span.field-value {{ cart.ship_price_real | formatShipPrice }}

          div.fields.checkout-cart__shipment-fee(v-if="cart.distance > 0")
            span.field-caption Khoảng cách
              em (lấy theo AhaMove)
            span.field-value {{ cart.distance }} km

          div.fields.checkout-cart__shipment-fee(v-else-if="cart.ship_price_real === -1")
            span.field-caption Phí vận chuyển
            span.field-value Nhà hàng sẽ gọi điện lại để xác nhận

          div.fields.checkout-cart__shipment-fee(v-if="cart.ship_price_real === -1")
            span.field-caption Nhà hàng sẽ liên hệ lại.

        p(style="color: #666; font-size: 13px;margin: 8px 0;") (Phí ship có thể tăng nếu là đơn hàng đặt trước & giờ nhận hàng rơi vào cao điểm, thời tiết xấu ...)

        div.fields.checkout-cart__discount(v-if="cart.Discount_Amount > 0")
          span.field-caption Mã giảm giá
          span.field-value -{{cart.Discount_Amount | formatPrice}}
        div.checkout-cart__coupon(:class="[{'is-processing':cart.coupon_status === 'processing'},{'is-valid':cart.coupon_status === 'valid'},{'is-invalid':cart.coupon_status === 'invalid'}]")
          input( v-model="cart.coupon_code" type="text",placeholder="Nhập mã giảm giá (nếu có)" :class="[{'is-processing':cart.coupon_status === 'processing'},{'is-valid':cart.coupon_status === 'valid'},{'is-invalid':cart.coupon_status === 'invalid'}]")
          div.message__button
            span(v-if="cart.coupon_status === 'processing'" class="coupon_status coupon_processing")
              | Đang kiểm tra
            span(v-else-if="cart.coupon_status === 'valid'" class="coupon_status coupon_valid")
              | Đã áp dụng
            span(v-else-if="cart.coupon_status === 'invalid'" class="coupon_status coupon_invalid")
              | Mã không hợp lệ
            span(v-else class="coupon_status coupon_normal")
              | &nbsp;

            template(v-if="cart.coupon_status === 'processing'")
              button.is-applying(@click.prevent="onCouponApply" :class="[{'is-processing':cart.coupon_status === 'processing'},{'is-valid':cart.coupon_status === 'valid'},{'is-invalid':cart.coupon_status === 'invalid'}]")
                | Checking ...
            template(v-else-if="cart.coupon_status === 'valid'")
              button.is-applying(@click.prevent="onRemoveCoupon" :class="[{'is-processing':cart.coupon_status === 'processing'},{'is-valid':cart.coupon_status === 'valid'},{'is-invalid':cart.coupon_status === 'invalid'}]")
                | Xóa
            template(v-else-if="cart.coupon_status === 'invalid'")
              button.is-applying(@click.prevent="onRemoveCoupon" :class="[{'is-processing':cart.coupon_status === 'processing'},{'is-valid':cart.coupon_status === 'valid'},{'is-invalid':cart.coupon_status === 'invalid'}]")
                | Xóa
            template(v-else)
              button.is-applying(@click.prevent="onCouponApply" :class="[{'is-processing':cart.coupon_status === 'processing'},{'is-valid':cart.coupon_status === 'valid'},{'is-invalid':cart.coupon_status === 'invalid'}]")
                | Áp dụng

        div.fields.checkout-cart__amount
          span.field-caption Tổng tiền thanh toán
          span.field-value {{ cart | totalPricePayment | formatPrice }}
        div.cart_notice(v-if="cart.ship_price_real === -1").d-flex.justify-content-end
          p.text-right
            i (chưa bao gồm ship)
    IconPaperBottom()


</template>
<script>
  import IconPaperTop from "./IconPaperTop";
  import IconPaperBottom from "./IconPaperBottom";
  import IconRemove from "./icons/IconRemove";
  import CartQuantity from "./CartQuantity";

  import {bus} from '../main'

  export default {
    name: 'CartItems',
    components: {CartQuantity, IconRemove, IconPaperBottom, IconPaperTop},
    data () {
      return {
        qty: 1,
      }
    },
    props: {
      cart: Object,
      shipType: Object
    },
    methods: {
      onCouponApply() {
        bus.$emit('checkCoupon', 'coupon');
      },
      onRemoveCoupon() {
        bus.$emit('removeCoupon', 'coupon');
      },
      removeItem(index) {
        this.cart.ordersItem.splice(index, 1);
        bus.$emit('updateSessionCart', 'remove');
      },
      updateCart() {
        bus.$emit('updateSessionCart', 'qty');
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/CartItems.vue